
import http from "../context/AxiosProvider";
import { BaseResponse } from "../models/baseModel";
import { ResponseCode } from "../models/responseCodeModel";

export class HttpClient {

    async get<T>(url: string, options = {}): Promise<BaseResponse<T | any>> {
        return await http.get(url, options).then(res => res.data);
    }

    async post<T>(url: string, param?: any, options = {}): Promise<BaseResponse<T | any>> {
        return await http
            .post(url, param, options).then(res => res.data);
    }

    async patch<T>(url: string, param?: any): Promise<BaseResponse<T | any>> {
        return await http
            .patch(url, param).then(res => res.data);
    }

    async put<T>(url: string, param?: any): Promise<BaseResponse<T | any>> {
        return await http
            .put(url, param).then(res => res.data);
    }

    async delete<T>(url: string): Promise<BaseResponse<T | any>> {
        return await http
            .delete(url).then(res => res.data);
    }

    async deleteByOptions<T>(url: string, param: any): Promise<BaseResponse<T | any>> {
        return await http
            .delete(url, {
                data: param
            }).then(res => res.data);
    }

}